<template>
  <li :class="{ active: isActive }" @click="setNewType">{{type}}</li>
</template>

<script>
  import Stash from 'services/Stash';

  export default {

    props: ['type'],

    data() {
      return {
        state: Stash.state,
      };
    },

    methods: {

      setNewType() {
        Stash.setType(this.type);
      },

    },

    computed: {

      isActive() {
        return this.type.toLowerCase() === this.activeType.toLowerCase();
      },

      activeType() {
        return this.state.type;
      },

    },

  };
</script>

<style scoped>
  li {
    margin: 0 5px;
    cursor: pointer;
    min-width: 80px;
    padding: 5px 15px;
    font-weight: lighter;
    display: inline-block;
    border: 1px solid #638E9C;
    user-select: none;
  }

  li.active {
    font-weight: bold;
    box-shadow: inset 0 0 0 1px #638E9C;
  }

  @media (max-width: 767px) {

    li {
      margin-bottom: 15px;
    }
  }
</style>



// WEBPACK FOOTER //
// ProjectType.vue?087fd10c